import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export interface PasswordSameAsOldErrorProps {
    errorMessage?: string;
}

export const PasswordSameAsOldError = ({
    errorMessage,
}: PasswordSameAsOldErrorProps) => {
    const { t } = useTranslation();
    return (
        <Alert data-testid="kratos-password-error" severity="error">
            {errorMessage || t('formErrors.kratosPasswordError.sameAsOld')}
        </Alert>
    );
};
